/** FNV-1a 32-bit — ổn định giữa node/browser, không dùng Math.random(). */
export const hashString = (input: string): number => {
  let hash = 2166136261;
  for (let i = 0; i < input.length; i += 1) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
};

/** LCG gắn seed, mỗi lần gọi trả [0, 1). */
export const createRng = (seed: number): (() => number) => {
  let state = seed >>> 0 || 1;
  return () => {
    state = (Math.imul(state, 1664525) + 1013904223) >>> 0;
    return state / 4294967296;
  };
};

export const rngFor = (dateFrom: string, stream: string): (() => number) =>
  createRng(hashString(`${dateFrom}|${stream}`));
